<!-- eslint-disable no-undef -->
<template>
  <div>
    <div id="mapBox" class="mapBox">

    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressPreview',
  props: {
    data: Object
  },
  mounted () {
    this.initMap()
  },
  methods: {
    initMap () {
      if (!this.data || !this.data.items || !this.data.items.location) {
        return
      }

      if (typeof TMap === 'undefined') {
        console.error('TMap is not defined. Make sure the TMap library is loaded.')
        return
      }

      // eslint-disable-next-line no-undef
      var center = new TMap.LatLng(this.data.items.location.lat, this.data.items.location.lng)
      // 初始化地图
      // eslint-disable-next-line no-undef
      this.map = new TMap.Map('mapBox', {
        rotation: 0,
        pitch: 0,
        zoom: 16,
        center: center,
        zIndex: 0
      })

      this.addMarker(center)
    },

    addMarker (center) {
    // 如果存在旧的标记，先移除
      if (this.marker) {
        this.marker.setMap(null)
      }
      if (this.label) {
        this.label.setMap(null)
      }

      // 添加标记点
      // eslint-disable-next-line no-undef, no-new
      this.marker = new TMap.MultiMarker({
        map: this.map,
        styles: {
        // eslint-disable-next-line no-undef
          marker: new TMap.MarkerStyle({
            width: 20,
            height: 20,
            anchor: { x: 10, y: 30 },
            zIndex: 0
          })
        },
        geometries: [{
          position: center,
          id: 'marker'
        }]
      })

      // 添加文本标签
      // eslint-disable-next-line no-undef
      this.label = new TMap.MultiLabel({
        map: this.map,
        styles: {
        // eslint-disable-next-line no-undef
          label: new TMap.LabelStyle({
            color: '#333333',
            size: 14,
            offset: { x: 0, y: -45 }, // 调整标签位置，离标记点稍远一点
            padding: { top: 6, right: 10, bottom: 6, left: 10 }, // 增加内边距
            backgroundColor: 'rgba(255, 255, 255, 0.95)', // 半透明背景
            borderRadius: 4, // 增加圆角
            borderWidth: 1,
            borderColor: '#e0e0e0', // 淡化边框颜色
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)' // 添加阴影效果
          })
        },
        geometries: [{
          position: center,
          id: 'label',
          content: this.data.items.title || '当前位置' // 显示地址文本
        }]
      })
    },

    updateMapLocation () {
      if (!this.map || !this.data.items.location) return

      // eslint-disable-next-line no-undef
      const newCenter = new TMap.LatLng(this.data.items.location.lat, this.data.items.location.lng)
      this.map.setCenter(newCenter)
      // 更新标记位置
      this.addMarker(newCenter)
    }
  },

  watch: {
    'data.items': {
      handler (newVal) {
        if (newVal && newVal.location && newVal.location.lat && newVal.location.lng) {
          if (!this.map) {
            this.initMap()
          } else {
            this.updateMapLocation()
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 14px;
  padding: 15px 0 5px 15px;
  background-color: #eff2f7;
  font-weight: normal;
  color: #666;
}

.text {
  font-size: 14px;
  padding: 12px 15px;
  white-space: pre-line;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
  background-color: white;
  text-align: center;
}

.mapBox {
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/address/AddressPreview.vue